var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAlternateEmail = function SvgAlternateEmail(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.002 21.004H12A9.004 9.004 0 1 1 21.004 12v1.5a2.501 2.501 0 1 1-5.002 0V12A4.002 4.002 0 0 0 12 7.998v0A4.002 4.002 0 1 0 16.002 12"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAlternateEmail);
export default ForwardRef;